import * as React from "react";
import { forwardRef } from "react";

const SvgMicrosoft = ({
  title,
  titleId,
  ...props
}, ref) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="48px" height="48px" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="#ff5722" d="M6 6H22V22H6z" /><path fill="#4caf50" d="M26 6H42V22H26z" /><path fill="#03a9f4" d="M6 26H22V42H6z" /><path fill="#ffc107" d="M26 26H42V42H26z" /></svg>;

const ForwardRef = forwardRef(SvgMicrosoft);
export default ForwardRef;